import { useContext } from 'react';

import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ConfigContext } from '../../../aurr/contexts/ConfigContext';
import type { ApiRequestProps } from '../../../common/interface';
import { collectionItemArraySchema } from '../../../common/schema';
import type { CollectionItemArray } from '../../../common/type';
import { COLLECTION_ITEM_QUERY_KEY } from '../constants';

interface CollectionRequestParams extends ApiRequestProps {
  id: string;
  itemKeys: string[];
  pathname?: string;
}

export const useCollectionItemsData = ({
  id,
  itemKeys,
  ...params
}: CollectionRequestParams) => {
  const { COMMUNITY_FUNCTIONS_URL } = useContext(ConfigContext);
  const { baseURL, ...restParams } = params;

  const parsedBaseUrl = baseURL || COMMUNITY_FUNCTIONS_URL;
  const axiosConfig = {
    baseURL: `${parsedBaseUrl}/store/v1/collections/${id}/items`,
  };

  return useQuery<CollectionItemArray | undefined>({
    queryKey: [COLLECTION_ITEM_QUERY_KEY, parsedBaseUrl, id],
    queryFn: async (): Promise<CollectionItemArray | undefined> => {
      const api = axios.create(axiosConfig);

      const response = await api
        .get('', { params: { provider: 'aws', ...restParams } })
        .catch(reason => {
          // eslint-disable-next-line no-console
          console.error('Error fetching Collection Items data: ', reason);
          return reason.response;
        });

      const collectionResponse = collectionItemArraySchema.safeParse(
        response?.data?.collection_items
      );
      if (collectionResponse.success) {
        return collectionResponse.data as CollectionItemArray;
      }
      return undefined;
    },
    enabled: !!id,
  });
};
